import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import Const from '../../util/Constants';
import Display from '../../util/Display';
import { Table } from "react-bootstrap";

const InfoItem = ({ label, value, highlight = false }) => (
  <div>
    <div style={{ fontSize: "12px", color: "#64748b", marginBottom: "4px" }}>
      {label}
    </div>
    <div style={{ 
      fontSize: "14px", 
      fontWeight: highlight ? 600 : 500, 
      color: highlight ? "#2563eb" : "#1e293b" 
    }}>
      {value || "-"}
    </div>
  </div>
);

class SalesOrderDetails extends React.Component {
  constructor(props) {
    super(props);
    this.designView = props.designView || 1;
    this.model = props.model;
    this.sale = props.sale;
    this.excludedFields = props.excludedFields || [];
    
    const fields = props.model.fields;
    const keys = Object.keys(fields);
    this.visibleFields = [];

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (
        key === Const.Status ||
        (key.includes(Const.T_Product) && key.includes(Const.Opt)) ||
        key === 'name' || key === 'model' || 
        fields[key].status === Const.Trash || 
        this.excludedFields.includes(key)
      ) {
        continue;
      }
      if (fields[key].visible === Const.True) {
        const field = { ...fields[key], key };
        this.visibleFields.push(field);
      }
    }
  }
  formatCurrency(amount) {
    if (!amount) return "₹0";
    return `₹${amount.toLocaleString('en-IN')}`;
  }
  calculatePaymentProgress() {
    const { sale } = this.props;
    const paidAmount = sale.paid_amount || 0;
    const totalValue = sale.total || sale.pretax || 0;
    
    if (!totalValue || totalValue === 0) return 0;
    
    return ((paidAmount || 0) / totalValue) * 100;
  }

  getBookingData() {
    const { sale, model } = this.props;
    
    return {
      booking: {
        bookingDate: Display.FieldValue(sale, 'created_date', model.fields),
        bookingStatus: Display.FieldValue(sale, 'status', model.fields),
        bookingPrice: sale.pretax,
        agreementPrice: sale.total,
        totalValue: sale.total,
        paidAmount: sale.paid_amount,
        pendingAmount: (sale.total || 0) - (sale.paid_amount || 0),
        discountPercent: sale.discountp || sale.discount || 0,
        salesType: Display.FieldValue(sale, 'sales_type', model.fields),
        probability: Display.FieldValue(sale, 'probability', model.fields),
        source: Display.FieldValue(sale, 'source', model.fields)
      }
    };
  }
  renderDesign1() {
    const fieldUI = [];
    let count = this.visibleFields.length;
    count = Math.ceil(count / 3);
    let index = this.props.i * count;
    
    for(; index < ((this.props.i + 1) * count) && index < this.visibleFields.length; index++ ) {
      if(!this.props.isCompleted && this.visibleFields[index].key === 'pending') continue;
      const key = this.visibleFields[index].key;
      const value = Display.FieldValue(this.props.sale, key, this.props.model.fields);
      fieldUI.push(
        <tr key={`d_f_${this.visibleFields[index].key}`}>
          <th>{this.visibleFields[index].label_name}</th><td>:</td><td>{value}</td>
        </tr>
      );
    }

    return(
      <div className="col-md-4">
        <Table striped bordered hover className="borderRemove">
          <thead><tr className="tableHeading"><td colSpan="3">Details</td></tr></thead>
          <tbody>{fieldUI}</tbody>
        </Table>
      </div>      
    );
  }

renderDesign2() {
    const paymentProgress = this.calculatePaymentProgress();
    const totalValue = this.sale.total || this.sale.pretax || 0;
    const paidAmount = this.sale.paid_amount || 0;
    const usedFieldKeys = new Set();
        const isFieldVisible = (fieldName) => {
        const fieldConfig = this.model?.fields?.[fieldName];
        if (!fieldConfig) return false;
        if (fieldConfig.visible !== Const.True) return false;
        const value = Display.FieldValue(this.sale, fieldName, this.model.fields);
        return value !== undefined && value !== null && value !== '' && value !== '0';
    };
    const formatCurrencyValue = (amount) => {
        if (!amount || amount === '0') return '₹0';
        const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
        if (isNaN(numAmount)) return amount;
        return `₹${numAmount.toLocaleString('en-IN')}`;
    };
    const formatPercentageValue = (value) => {
        if (!value || value === '0') return '0%';
        return `${value}%`;
    };
    const fieldGroups = {
        propertyDetails: [
              { 
                key: 'end_date', 
                label: this.model?.fields?.end_date?.label_name || "Booking Date",
                show: isFieldVisible('end_date')
            },
            { 
                key: 'build_area', 
                label: this.model?.fields?.build_area?.label_name || "Build Area",
                show: isFieldVisible('build_area')
            },
            { 
                key: 'carpet_area', 
                label: this.model?.fields?.carpet_area?.label_name || "Carpet Area",
                show: isFieldVisible('carpet_area')
            }
        ],
        pricing: [
            { 
                key: 'base_price', 
                label: this.model?.fields?.base_price?.label_name || "Base Price / sqft",
                show: isFieldVisible('base_price'),
                isCurrency: true
            },
            { 
                key: 'price', 
                label: this.model?.fields?.price?.label_name || "Price",
                show: isFieldVisible('price'),
                isCurrency: true
            },
            { 
                key: 'floor_rise', 
                label: this.model?.fields?.floor_rise?.label_name || "Floor Rise",
                show: isFieldVisible('floor_rise'),
                isCurrency: true
            },
            { 
                key: 'agreement_price', 
                label: this.model?.fields?.agreement_price?.label_name || "Agreement Rise",
                show: isFieldVisible('agreement_price'),
                isCurrency: true
            },
            { 
                key: 'discount', 
                label: this.model?.fields?.discount?.label_name || "Discount",
                combined: true,
                amountField: 'discount',
                percentField: 'discountp',
                show: isFieldVisible('discount') || isFieldVisible('discountp')
            },
        ],
        taxes: [
            { 
                key: 'gst', 
                label: this.model?.fields?.gst?.label_name || "GST",
                combined: true,
                percentField: 'gst',
                amountField: 'gst_p',
                show: isFieldVisible('gst') || isFieldVisible('gst_p')
            },
            { 
                key: 'stamp_duty', 
                label: this.model?.fields?.stamp_duty?.label_name || "Stamp Duty",
                combined: true,
                percentField: 'stamp_duty_p', 
                amountField: 'stamp_duty',
                show: isFieldVisible('stamp_duty') || isFieldVisible('stamp_duty_p')
            },
            { 
                key: 'reg_charges', 
                label: this.model?.fields?.reg_charges?.label_name || "Registration Charge",
                combined: true,
                percentField: 'reg_charges_p', 
                amountField: 'reg_charges',
                show: isFieldVisible('reg_charges') || isFieldVisible('reg_charges_p')
            },
            { 
                key: 'commission', 
                label: this.model?.fields?.commission?.label_name || "Commission",
                combined: true,
                amountField: 'commission',
                percentField: 'commission_p',
                show: isFieldVisible('commission') || isFieldVisible('commission_p')
            }
        ],
        charges: [
            { 
                key: 'parking_charges', 
                label: this.model?.fields?.parking_charges?.label_name || "Parking Charges",
                show: isFieldVisible('parking_charges'),
                isCurrency: true
            },
            { 
                key: 'development_charges', 
                label: this.model?.fields?.development_charges?.label_name || "Development Charges",
                show: isFieldVisible('development_charges'),
                isCurrency: true
            },
    
            { 
                key: 'society_charges', 
                label: this.model?.fields?.society_charges?.label_name || "Commission",
                show: isFieldVisible('society_charges'),
                isCurrency: true
            },
            { 
                key: 'mainten_charges', 
                label: this.model?.fields?.mainten_charges?.label_name || "Maintenance Charges",
                show: isFieldVisible('mainten_charges'),
                isCurrency: true
            },
        ],
  
    };

    // Collect all used field keys from fieldGroups
    Object.values(fieldGroups).forEach(group => {
        group.forEach(field => {
            if (field.show) {
                if (field.combined) {
                    if (field.percentField) usedFieldKeys.add(field.percentField);
                    if (field.amountField) usedFieldKeys.add(field.amountField);
                } else {
                    usedFieldKeys.add(field.key);
                }
            }
        });
    });
    const remainingFields = this.visibleFields.filter(field => {
        if (usedFieldKeys.has(field.key)) {
            return false;
        }
        const value = Display.FieldValue(this.sale, field.key, this.model.fields);
        if (value === undefined || value === null || value === '' || value === '0') {
            return false;
        }
        return true;
    });

    const getCombinedValue = (fieldConfig) => {
        if (fieldConfig.combined) {
            const percentValue = Display.FieldValue(this.sale, fieldConfig.percentField, this.model.fields);
            const amountValue = Display.FieldValue(this.sale, fieldConfig.amountField, this.model.fields);
            
            if (percentValue && amountValue) {
                // Add % symbol for percentage and format currency
                return `${percentValue}% (${formatCurrencyValue(amountValue)})`;
            } else if (percentValue) {
                return `${percentValue}%`;
            } else if (amountValue) {
                return formatCurrencyValue(amountValue);
            }
            return '-';
        }
        
        const rawValue = Display.FieldValue(this.sale, fieldConfig.key, this.model.fields);
        if (!rawValue || rawValue === '0') return '-';
        
        // Apply formatting based on field type
        if (fieldConfig.isCurrency) {
            return formatCurrencyValue(rawValue);
        }
        
        return rawValue || '-';
    };

    // Helper function to render a field group
    const renderFieldGroup = (groupName, fields, groupLabel) => {
        // Filter fields that should be shown
        const groupFields = fields.filter(field => field.show);
        
        if (groupFields.length === 0) return null;

        return (
            <div key={groupName} style={{ marginBottom: '24px' }}>
                {groupLabel && (
                    <h6 style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#374151',
                        marginBottom: '16px',
                        paddingBottom: '8px',
                        borderBottom: '2px solid #e5e7eb'
                    }}>
                        {groupLabel}
                    </h6>
                )}
                <Row className="g-3">
                    {groupFields.map((fieldConfig, index) => (
                        <Col md={fieldConfig.highlight ? 4 : 3} key={fieldConfig.key || `${fieldConfig.percentField}_${fieldConfig.amountField}`}>
                            <div className="mb-2">
                                <small style={{ 
                                    fontSize: '12px', 
                                    fontWeight: '700', 
                                    color: '#6b7280',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}>
                                    {fieldConfig.label}
                                </small>
                                <div style={{ 
                                    fontSize: fieldConfig.highlight ? '16px' : '14px', 
                                    fontWeight: fieldConfig.highlight ? '700' : '600',
                                    color: fieldConfig.highlight ? '#1f2937' : '#374151',
                                    marginTop: '4px',
                                    wordBreak: 'break-word'
                                }}>
                                    {getCombinedValue(fieldConfig)}
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
        );
    };

    const renderRemainingFields = () => {
        if (remainingFields.length === 0) return null;

        const formatRemainingField = (field, value) => {
            if (!value || value === '0') return '-';
            
            // Format currency fields
            if (field.key.includes('amount') || 
                field.key.includes('price') || 
                field.key.includes('total') || 
                field.key.includes('cost') ||
                field.key.includes('charges') ||
                field.key === 'pretax' ||
                field.key === 'flat_price' ||
                field.key === 'base_price' ||
                field.key === 'floor_rise' ||
                field.key === 'price' ||
                field.key === 'commission' ||
                field.key === 'stamp_duty' ||
                field.key === 'agreement_price' ||
                field.key === 'pending' ||
                field.key === 'discount') {
                return formatCurrencyValue(value);
            }
            
            // Format percentage fields
            else if (field.key.includes('percent') || 
                     field.key.includes('probability') || 
                     field.key.includes('discount') ||
                     field.key.includes('_p') ||
                     field.key === 'gst' ||
                     field.key === 'commission_p' ||
                     field.key === 'stamp_duty_p' ||
                     field.key === 'reg_charges_p' ||
                     field.key === 'discountp') {
                return formatPercentageValue(value);
            }
            return value;
        };

        // Group remaining fields by category if possible, or just show as "Additional Information"
        return (
            <div style={{ marginBottom: '24px' }}>
                <h6 style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#374151',
                    marginBottom: '16px',
                    paddingBottom: '8px',
                    borderBottom: '2px solid #e5e7eb'
                }}>
                    Additional Information
                </h6>
                <Row className="g-3">
                    {remainingFields.map((field, index) => {
                        const value = Display.FieldValue(this.sale, field.key, this.model.fields);
                        const formattedValue = formatRemainingField(field, value);
                        
                        return (
                            <Col md={3} key={field.key}>
                                <div className="mb-2">
                                    <small style={{ 
                                        fontSize: '12px', 
                                        fontWeight: '700', 
                                        color: '#6b7280',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}>
                                        {field.label_name || field.key.replace(/_/g, ' ').toUpperCase()}
                                    </small>
                                    <div style={{ 
                                        fontSize: '14px', 
                                        fontWeight: '600',
                                        color: '#374151',
                                        marginTop: '4px',
                                        wordBreak: 'break-word'
                                    }}>
                                        {formattedValue || '-'}
                                    </div>
                                </div>
                            </Col>
                        );
                    })}
                </Row>
            </div>
        );
    };

    return (
        <Card
            style={{
                border: 'none',
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                marginBottom: '24px',
                background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)'
            }}
        >
            {/* Header */}
            <Card.Header
                style={{
                    backgroundColor: 'transparent',
                    borderBottom: '2px solid #e5e7eb',
                    padding: '20px 24px',
                    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)'
                }}
            >
                <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between' 
                }}>
                    
                    {/* LEFT SIDE - TITLE */}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                            style={{
                                width: '44px',
                                height: '44px',
                                borderRadius: '10px',
                                backgroundColor: '#3b82f6',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '14px',
                                boxShadow: '0 4px 8px rgba(59, 130, 246, 0.3)'
                            }}
                        >
                            <span style={{ color: 'white', fontSize: '20px', fontWeight: 'bold' }}>💰</span>
                        </div>

                        <div>
                            <h5 style={{ 
                                margin: 0, 
                                fontWeight: 700, 
                                color: '#1e293b',
                                fontSize: '18px'
                            }}>
                                Booking Information
                            </h5>
                            <p
                                style={{
                                    margin: '4px 0 0 0',
                                    fontSize: '13px',
                                    color: '#64748b',
                                    fontWeight: '500'
                                }}
                            >
                                Complete financial breakdown & property details
                            </p>
                        </div>
                    </div>

                    {/* RIGHT SIDE – TOTAL SUMMARY */}
                    <div style={{
                        textAlign: 'right',
                        padding: '8px 16px',
                        borderRadius: '10px',
                        background: '#ffffff',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                    }}>
                        <div style={{ 
                            fontSize: '12px',
                            color: '#131612ff',
                            fontWeight: 600,
                            textTransform: 'uppercase'
                        }}>
                            Total Amount
                        </div>

                        <div style={{
                            fontSize: '20px',
                            fontWeight: 700,
                            color: '#074c27ff',
                            marginTop: '2px'
                        }}>
                            {formatCurrencyValue(totalValue)}
                        </div>
                    </div>

                </div>
            </Card.Header>

            {/* Body */}
            <Card.Body style={{ padding: '28px' }}>
                {renderFieldGroup('property', fieldGroups.propertyDetails, 'Property Specifications')}
                {renderFieldGroup('pricing', fieldGroups.pricing, 'Pricing Details')}               
                {renderFieldGroup('taxes', fieldGroups.taxes, 'Taxes & Duties & Commission')}                
                {renderFieldGroup('charges', fieldGroups.charges, 'Additional Charges')}                                            
                {renderRemainingFields()}
            </Card.Body>
        </Card>
    );
}

formatFieldValue(field) {
    const rawValue = Display.FieldValue(this.sale, field.key, this.model.fields);
    
    if (!rawValue || rawValue === '0') return '-';
    
    // Format currency fields
    if (field.key.includes('amount') || 
        field.key.includes('price') || 
        field.key.includes('total') || 
        field.key.includes('cost') ||
        field.key.includes('charges') ||
        field.key === 'pretax' ||
        field.key === 'flat_price' ||
        field.key === 'base_price' ||
        field.key === 'floor_rise' ||
        field.key === 'price' ||
        field.key === 'commission' ||
        field.key === 'stamp_duty' ||
        field.key === 'agreement_price' ||
        field.key === 'pending' ||
        field.key === 'discount') {
        return this.formatCurrency(rawValue);
    }
    
    // Format percentage fields
    else if (field.key.includes('percent') || 
             field.key.includes('probability') || 
             field.key.includes('discount') ||
             field.key.includes('_p') ||
             field.key === 'gst' ||
             field.key === 'commission_p' ||
             field.key === 'stamp_duty_p' ||
             field.key === 'reg_charges_p' ||
             field.key === 'discountp') {
        return `${rawValue}%`;
    }
    // Format dates
    else if (field.key.includes('date')) {
        return rawValue;
    }

    return rawValue;
}
formatFieldValue(field) {
    const rawValue = Display.FieldValue(this.sale, field.key, this.model.fields);
    
    // Format currency fields
    if (field.key.includes('amount') || 
        field.key.includes('price') || 
        field.key.includes('total') || 
        field.key.includes('cost') ||
        field.key === 'pretax') {
        return this.formatCurrency(rawValue);
    }
    return rawValue;
}
  render() {
    return this.designView === 2 ? this.renderDesign2() : this.renderDesign1();
  }
}

export default SalesOrderDetails;